export const phoneToHuman = (phone: string) => {
  const digits = phone.replace(/\D/g, "");

  if (!digits.startsWith("380") || digits.length !== 12) {
    if (digits.length === 10) {
      const city = digits.slice(0, 3);
      const part1 = digits.slice(3, 6);
      const part2 = digits.slice(6, 8);
      const part3 = digits.slice(8, 10);

      return `(${city}) ${part1}-${part2}-${part3}`;
    }
    return phone;
  }

  const operator = digits.slice(3, 5);
  const part1 = digits.slice(5, 8);
  const part2 = digits.slice(8, 9);
  const part3 = digits.slice(9, 12);

  return `(0${operator}) ${part1}-${part2}-${part3}`;
};

export const amountToHuman = (amount: number, name = "грн") => {
  return `${amount / 100} ${name}`;
};
